import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import './styles/tokens.css';
import './styles/dashboard.css';
import './styles/platform.css';
import './styles/global.css';
import 'leaflet/dist/leaflet.css';
import { loadConfig } from './config/env';
import { Providers } from './app/providers';
import { router } from './app/routes';

async function boot() {
  const cfg = await loadConfig();

  // In fake-auth mode we may eventually want MSW for Events fixtures.
  // The worker is wired but not started by default — flip this on once
  // handlers exist that should intercept real requests.
  // if (cfg.AUTH_MODE === 'fake') {
  //   const { worker } = await import('./data/mocks/browser');
  //   await worker.start({ onUnhandledRequest: 'bypass' });
  // }
  void cfg;

  const container = document.getElementById('root');
  if (!container) throw new Error('Missing #root element');

  createRoot(container).render(
    <StrictMode>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </StrictMode>,
  );
}

boot().catch((err) => {
  // eslint-disable-next-line no-console
  console.error('[Biyahad bootstrap] failed', err);
  const container = document.getElementById('root');
  if (container) {
    container.innerHTML = `<div style="padding:24px;font-family:Heebo,sans-serif"><h1>שגיאה באתחול</h1><pre>${String(err)}</pre></div>`;
  }
});
